<template>
  <v-dialog
    v-model="dialog"
    max-width="800"
  >
    <v-data-table
      :headers="headers"
      :items="users"
      :loading="loading"
      class="elevation-1"
      :items-per-page="-1"
      hide-default-footer
    >

      <template v-slot:item.avg="{ item }">
        {{ item.avg ? timeToString(item.avg) : '-' }}
      </template>
      <template v-slot:item.max="{ item }">
        {{ item.max ? timeToString(item.max) : '-' }}
      </template>
      <template v-slot:item.min="{ item }">
        {{ item.min ? timeToString(item.min) : '-' }}
      </template>
      <template v-slot:item.started="{ item }">
        <b>{{ item.started ? '+' : '-' }}</b>
      </template>
      <template v-slot:item.finished="{ item }">
        <b>{{ item.finished ? '+' : '-' }}</b>
      </template>
    </v-data-table>
  </v-dialog>
</template>

<script>
import helper from '../../../plugins/helpers/mixin-helper'
export default {
  mixins: [
    helper
  ],
  data () {
    return {
      dialog: true,
      loading: false,
      users: [],
      headers: [
        {
          text: 'Player',
          align: 'start',
          sortable: true,
          value: 'PlayerNickname'
        },
        {
          text: 'Avg',
          align: 'start',
          sortable: true,
          value: 'avg'
        },
        {
          text: 'Max',
          align: 'start',
          sortable: true,
          value: 'max'
        },
        {
          text: 'Min',
          align: 'start',
          sortable: true,
          value: 'min'
        }
      ]
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  async mounted () {
    await this.getData()

    if (
      this.$route.query.start_narration_node ||
      this.$route.query.finish_narration_node ||
      (this.$route.query.finish && this.$route.query.finish !== 'null')
    ) {
      this.headers = this.headers.concat([
        {
          text: 'Node Started',
          align: 'center',
          sortable: true,
          value: 'started'
        },
        {
          text: 'Node Finished',
          align: 'center',
          sortable: true,
          value: 'finished'
        }
      ])
    } else {
      this.headers = this.headers.concat([
        {
          text: 'Sessions',
          align: 'start',
          sortable: true,
          value: 'sessions'
        }
      ])
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    async getData () {
      if (!this.$route.query.build_id && !this.$route.query.user_id && !this.$route.query.session_id) {
        return
      }

      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/telemetry/playtime/statistic`, {
          params: {
            build_id: this.$route.query.build_id,
            user_id: this.$route.query.user_id,
            session_id: this.$route.query.session_id,
            start_narration_node: this.$route.query.start_narration_node,
            finish_narration_node: this.$route.query.finish_narration_node,
            finish_event_id: this.$route.query.finish && this.$route.query.finish !== 'null' ? this.$route.query.finish[1] : null,
            filteredByPlayer: true,
            session_min_time: this.$route.query.session_min_time
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.users = data


      }
      this.loading = false
    }
  }
}
</script>